import ReuseableTable from "components/Tables/ReuseableTable";
import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";

// Leaderboard Table
const leaderboardColumns = [
  "Fan Name",
  "Email",
  "Rewarded Amount",
  "Total Points",
];
const leaderboardKeyMap = {
  "Fan Name": "fanName",
  Email: "email",
  "Rewarded Amount": "rewardedAmount",
  "Total Points": "totalPoints",
};

// Round 1,2 Table
const roundsColumns = ["Fan Name", "Email", "Total Points"];
const roundsKeyMap = {
  "Fan Name": "fanName",
  Email: "email",
  "Total Points": "totalPoints",
};

// Round 1 Athlete Table
const round1Columns = ["Athlete Name", "Email", "Athlete ID", "Total Points"];
const round1KeyMap = {
  "Athlete Name": "name",
  Email: "email",
  "Athlete ID": "athleteID",
  "Total Points": "totalPoints",
};

// Round 2 Athlete Table
const round2Columns = [
  "Athlete Name",
  "Email",
  "Seasonal Badges",
  "Momentos",
  "Talking Badges",
  "Sport Badges",
  "Endorsement Badges",
  "Chats",
];

const round2KeyMap = {
  "Athlete Name": "name",
  Email: "email",
  "Seasonal Badges": "seasonal_badges",
  Momentos: "momentos",
  "Talking Badges": "talking_badges",
  "Sport Badges": "sport_badges",
  "Endorsement Badges": "endorsement_badges",
  Chats: "chats",
};

const SportContestLeaderboard = ({ showModal, handleModalToggle, contest }) => {
  const [round1Details, setRound1Details] = useState([]);
  const [round2Details, setRound2Details] = useState([]);
  const [athletePoints, setAthletePoints] = useState(0);

  const [round1Modal, setRound1Modal] = useState(false);
  const [round2Modal, setRound2Modal] = useState(false);

  const round1ModalToggle = () => {
    if (round1Modal) {
      setAthletePoints(0);
    }
    setRound1Modal(!round1Modal);
  };

  const round2ModalToggle = () => setRound2Modal(!round2Modal);

  const leaderboardData = contest?.leaderBoard?.map((item) => ({
    fanName: item?.fanName,
    email: item?.email,
    rewardedAmount: contest?.rewardedAmount,
    totalPoints: item?.totalPoints,
  }));

  const round1AthleteData = round1Details?.map((item) => ({
    name: item?.first_name + " " + item?.last_name,
    email: item?.email,
    athleteID: item?.athleteID,
    totalPoints: athletePoints,
  }));

  const round2AthleteData = round2Details?.map((item) => ({
    name: item?.athleteData?.first_name + " " + item?.athleteData?.last_name,
    email: item?.athleteData?.email,
    seasonal_badges: item?.seasonal_badges || "0",
    momentos: item?.momentos || "0",
    talking_badges: item?.talking_badges || "0",
    sport_badges: item?.sport_badges || "0",
    endorsement_badges: item?.endorsement_badges || "0",
    chats: item?.chats || "0",
  }));

  const round1Actions = (item) => (
    <Button
      color="primary"
      size="sm"
      onClick={() => {
        setRound1Details(item?.pointDetails);
        setAthletePoints(item?.totalPoints);
        round1ModalToggle();
      }}
    >
      View Details
    </Button>
  );

  const round2Actions = (item) => (
    <Button
      color="primary"
      size="sm"
      onClick={() => {
        setRound2Details(item?.pointDetails);
        round2ModalToggle();
      }}
    >
      View Details
    </Button>
  );

  return (
    <>
      <Modal isOpen={showModal} toggle={handleModalToggle} size="xl" centered>
        <ModalHeader toggle={handleModalToggle}>Leaderboard</ModalHeader>
        <ModalBody>
          <Card
            className="overflow-hidden"
            style={{ boxShadow: "1px 1.5px 2px rgba(0, 0, 0, 0.05)" }}
          >
            <CardHeader className="p-3">
              <h5 className="mb-0 text-uppercase">Leaderboard</h5>
            </CardHeader>
            <CardBody className="p-0">
              <ReuseableTable
                columns={leaderboardColumns}
                keyMap={leaderboardKeyMap}
                data={leaderboardData}
              />
            </CardBody>
          </Card>

          <Card
            className="overflow-hidden mt-3"
            style={{ boxShadow: "1px 1.5px 2px rgba(0, 0, 0, 0.05)" }}
          >
            <CardHeader className="p-3">
              <h5 className="mb-0 text-uppercase">Round 1</h5>
            </CardHeader>
            <CardBody className="p-0">
              <ReuseableTable
                columns={roundsColumns}
                keyMap={roundsKeyMap}
                data={contest?.round1}
                renderActions={round1Actions}
              />
            </CardBody>
          </Card>

          <Card
            className="overflow-hidden mt-3"
            style={{ boxShadow: "1px 1.5px 2px rgba(0, 0, 0, 0.05)" }}
          >
            <CardHeader className="p-3">
              <h5 className="mb-0 text-uppercase">Round 2</h5>
            </CardHeader>
            <CardBody className="p-0">
              <ReuseableTable
                columns={roundsColumns}
                keyMap={roundsKeyMap}
                data={contest?.round2}
                renderActions={round2Actions}
              />
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleModalToggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={round1Modal} toggle={round1ModalToggle} size="xl" centered>
        <ModalHeader toggle={round1ModalToggle}>Athlete Details</ModalHeader>
        <ModalBody>
          <Card
            className="overflow-hidden"
            style={{ boxShadow: "1px 1.5px 2px rgba(0, 0, 0, 0.05)" }}
          >
            <CardBody className="p-0">
              <ReuseableTable
                columns={round1Columns}
                keyMap={round1KeyMap}
                data={round1AthleteData}
              />
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={round1ModalToggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={round2Modal} toggle={round2ModalToggle} size="xl" centered>
        <ModalHeader toggle={round2ModalToggle}>Athlete Details</ModalHeader>
        <ModalBody>
          <Card
            className="overflow-hidden"
            style={{ boxShadow: "1px 1.5px 2px rgba(0, 0, 0, 0.05)" }}
          >
            <CardBody className="p-0">
              <ReuseableTable
                columns={round2Columns}
                keyMap={round2KeyMap}
                data={round2AthleteData}
              />
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={round2ModalToggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SportContestLeaderboard;
